module.exports = __webpack_public_path__ + "img/icon-arrow-down.65765fac.svg";